import { NgModule } from '@angular/core';
import { NebulaAngularComponent } from './nebula-angular.component';



@NgModule({
  declarations: [NebulaAngularComponent],
  imports: [
  ],
  exports: [NebulaAngularComponent]
})
export class NebulaAngularModule { }
